import { IconProductVasStandard16, IconVasAuction16, IconVasPremium16, IconVasTop16 } from '@cian/ui-kit';

import { type VasListItem } from '../types';

export function getAuctionVasListItem(title: string | null): VasListItem {
  const id = 'auction';

  const icon = <IconVasAuction16 color="warning_100" data-testid={`vas-icon.${id}`} />;

  const vasListItem: VasListItem = {
    icon,
    id,
    tooltip: {
      description:
        'Аукцион – это способ увеличить частоту показов вашего объявления. Чем выше ставка, тем чаще ваше объявление будет показано в результатах поиска.',
      icon,
      title: 'Аукцион',
    },
  };

  if (title) {
    vasListItem.title = title;
  }

  return vasListItem;
}

export function getPremiumVasListItem(): VasListItem {
  const id = 'premium';

  const icon = <IconVasPremium16 color="warning_100" data-testid={`vas-icon.${id}`} />;

  return {
    icon,
    id,
    tooltip: {
      description:
        'Премиум-объявления выделены в результатах поиска за счёт брендирования. Такие объявления показываются в 1.5 раза чаще обычных.',
      icon,
      title: 'Премиум',
    },
  };
}

export function getTop3VasListItem(): VasListItem {
  const id = 'top3';

  const icon = <IconVasTop16 color="warning_100" data-testid={`vas-icon.${id}`} />;

  return {
    icon,
    id,
    tooltip: {
      description:
        'Топ-объявления самые заметные в результатах поиска за счёт больших фотографий и брендирования. Такие объявления показываются в 3 раза чаще обычных.',
      icon,
      title: 'Топ',
    },
  };
}

export function getStandardVasListItem(): VasListItem {
  const id = 'standard';

  const icon = <IconProductVasStandard16 color="warning_100" data-testid={`vas-icon.${id}`} />;

  return {
    icon,
    id,
    tooltip: {
      description: 'Объявления располагаются ниже объявлений с продвижением Топ и Премиум, но выше Публикаций.',
      icon,
      title: 'Стандарт',
    },
  };
}
